import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ViewComponent } from './pages/view/view.component';
import { MasterComponent } from '../layout/pages/master/master.component';
import { AuthGuard } from '../auth/auth.guard';

const routes: Routes = [
  {
    path: 'view',
    component: MasterComponent,
    canActivate: [AuthGuard],
    children: [
      {
        component: ViewComponent,
        path: '**'
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ViewRoutingModule { }
